import { regeneratorRuntime as _regeneratorRuntime, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { __awaiter, __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import styled from 'styled-components';
import { memoize } from 'lodash';
import shortId from 'shortid';
import { px2rem } from '../../helpers/rem.mjs';
import { REGEXP_EMOJI, REGEXP_NATIVE_EMOJI } from '../../helpers/moimDown/tokenizer.mjs';

var EmojiWrapper = styled.span.withConfig({
  displayName: "EmojiWrapper",
  componentId: "sc-1p89wfc-0"
})(["padding-right:", ";"], px2rem(2));
// NOTE: 여기 부분 성능 개선 필요
var parse = memoize(function (value) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var ALL_REGEXP, elementHolder, match, lastCursor, matchText, matchPos, prevText;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ALL_REGEXP = new RegExp([REGEXP_EMOJI, REGEXP_NATIVE_EMOJI].join("|"), "g");
          elementHolder = [];
          match = null;
          lastCursor = 0;
          while ((match = ALL_REGEXP.exec(value)) !== null) {
            matchText = match[0];
            matchPos = match.index;
            prevText = value.substring(lastCursor, matchPos);
            elementHolder.push(prevText);
            elementHolder.push(jsx(EmojiWrapper, {
              children: matchText
            }, "emoji-safe-".concat(matchText, "-").concat(shortId())));
            lastCursor = matchPos + matchText.length;
          }
          if (value === null || value === undefined) {
            elementHolder.push("");
          } else {
            elementHolder.push(value.substr(lastCursor));
          }
          return _context.abrupt("return", elementHolder);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
});
var NativeEmojiSafeText = /*#__PURE__*/React__default.memo(function (_a) {
  var value = _a.value,
    rest = __rest(_a, ["value"]);
  var _React$useState = React__default.useState([value]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    elements = _React$useState2[0],
    setElements = _React$useState2[1];
  var getElements = React__default.useCallback(function () {
    parse(value).then(function (result) {
      setElements(result);
    });
  }, [value]);
  React__default.useLayoutEffect(function () {
    getElements();
  }, [getElements]);
  return jsx("span", Object.assign({}, rest, {
    children: elements
  }));
});

export { NativeEmojiSafeText };
